import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "upload-container" }
const _hoisted_2 = ["accept"]
const _hoisted_3 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "upload-content" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 0,
  class: "upload-actions mt-2"
}

import { ref, computed, onMounted, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modelValue: {},
    accept: {},
    alt: {},
    maxSize: {},
    imageUrl: {}
  },
  emits: ['update:modelValue', 'upload', 'remove'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const fileInput = ref<HTMLInputElement>()
const selectedFile = ref<File | null>(null)
const imageLoadError = ref(false)

onMounted(() => {
  // Reset error state on mount
  imageLoadError.value = false
})

watch(() => props.modelValue, (newValue) => {
  if (newValue instanceof File) {
    selectedFile.value = newValue
  } else if (typeof newValue === 'string') {
    selectedFile.value = null
  } else {
    selectedFile.value = null
  }
})

watch(() => props.imageUrl, (newUrl) => {
  if (newUrl) {
    imageLoadError.value = false // Reset error state when imageUrl changes
  }
})

const hasImage = computed(() => {
  return !!(props.modelValue || selectedFile.value || (props.imageUrl && !imageLoadError.value))
})

const displayImageUrl = computed(() => {
  console.log("Calculando displayImageUrl");
  
  // Prioridade: arquivo selecionado > modelValue > imageUrl prop
  if (selectedFile.value) {
    console.log("Usando arquivo selecionado:", selectedFile.value);
    return URL.createObjectURL(selectedFile.value)
  }
  if (props.modelValue instanceof File) {
    console.log("Usando modelValue como File:", props.modelValue);
    return URL.createObjectURL(props.modelValue)
  }

  if (typeof props.modelValue === 'string') {
    console.log("Usando modelValue como string:", props.modelValue);
    return props.modelValue
  }
  if (props.imageUrl && props.imageUrl != undefined && props.imageUrl != null && !imageLoadError.value) {
    console.log("Usando imageUrl prop:", props.imageUrl);
    return props.imageUrl
  }
  return null
})

function selectFile() {
  fileInput.value?.click()
}

function onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  
  if (!file) return
  
  // Validar tamanho se especificado
  if (props.maxSize && file.size > props.maxSize * 1024 * 1024) {
    alert(`Arquivo muito grande. Tamanho máximo: ${props.maxSize}MB`)
    return
  }
  
  // Validar tipo de arquivo
  if (props.accept && !file.type.match(props.accept.replace('*', '.*'))) {
    alert('Formato de arquivo não suportado')
    return
  }
  
  selectedFile.value = file
  imageLoadError.value = false // Reset error state
  emit('update:modelValue', file)
  emit('upload', file)
  
  // Limpar input para permitir selecionar o mesmo arquivo novamente
  input.value = ''
}

function removeImage() {
  selectedFile.value = null
  imageLoadError.value = false
  emit('update:modelValue', null)
  emit('remove')
}

function onImageError() {
  imageLoadError.value = true
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      accept: __props.accept,
      onChange: onFileSelected,
      style: {"display":"none"}
    }, null, 40, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["upload-area", { 'has-image': hasImage.value }])
    }, [
      (hasImage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: displayImageUrl.value ?? undefined,
              alt: __props.alt,
              class: "preview-img",
              onError: onImageError
            }, null, 40, _hoisted_4),
            _createElementVNode("div", { class: "image-overlay" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary me-2",
                onClick: selectFile,
                title: "Alterar imagem"
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-danger",
                onClick: removeImage,
                title: "Remover imagem"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
              ]))])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "upload-placeholder",
            onClick: selectFile
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-cloud-upload-alt upload-icon" }, null, -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "upload-text" }, "Clique para selecionar uma imagem", -1)),
              _createElementVNode("small", _hoisted_6, _toDisplayString(__props.accept || 'Formatos aceitos: JPG, PNG, GIF'), 1)
            ])
          ]))
    ], 2),
    (hasImage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary btn-sm me-2",
            onClick: selectFile
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-upload me-1" }, null, -1),
            _createTextVNode(" Alterar ", -1)
          ]))]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-danger btn-sm",
            onClick: removeImage
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-trash me-1" }, null, -1),
            _createTextVNode(" Remover ", -1)
          ]))])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})